import AOS from "aos";
import "aos/dist/aos.css";

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  const isMobile = window.innerWidth < 960;

  if (isMobile) {
    // Remove all data-aos-delay attributes for mobile
    document.querySelectorAll("[data-aos-delay]").forEach((el) => {
      el.removeAttribute("data-aos-delay");
    });
  }

  AOS.init({
    duration: 600,
    once: true,
  });

  window.addEventListener("load", () => {
    AOS.refresh();
  });
});
